module.exports = new __parcel__URL__("discovery.031e5fb7.jpg").toString();